import { objectToURLParams } from 'helpers/Utils';
import api from './api';

export const list = parameters =>
  api.get(`/admin/gasStation/fuels${objectToURLParams(parameters)}`);

export const update = (id, data) =>
  api.put(`/gasStation/${id}/fuelPrices`, data);
